/**
 * Declare all the skills details
 */
export interface Skills {
    /**
     * @remarks - flag to identify outbound skill
     */
    isOutbound: boolean;
  
    /**
     * @remarks - Unique identifier for skill
     */
    skillId: number;
  
    /**
     * @remarks - Name of the skill
     */
    skillName: string;

    /**
     * @remarks - Unique identifier for media type
     */
    mediaTypeId: number;
  
    /**
     * @remarks - Name of the media type
     */
    mediaTypeName: string;
     
    /**
     * @remarks - flag to identify active skill
     */
    isActive: boolean;
}
  